/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const MyTaskListHeader = ({
  userInfo,
  updateBulkTaskHandler = () => {},
  updateTaskInputHandler = () => {},
  setselectedTaskModerator = () => {},
  reloadList = () => {},
  updateScheduleStateHandler = () => {},
  downloadAsExcel = () => {},
  taskList = [],
  delayedTaskCount = 0,
  followingTaskCount = 0,
  inProgressTaskCount = 0,
  testingTaskCount = 0,
  pendingTaskCount = 0,
  completedTaskCount = 0,
  totalTaskHours = 0,
  totalTaskLogHours = 0,
  taskTotalPendingHours = 0,
  jsonFilterQuery = [],
  selectedTaskIds = [],
}) => {
  /* ---- bread crumb text ---- */
  const breadcrumbText = [{ title: "My Task" }];

  const { t } = useTranslation();

  const fmt = (val) => parseFloat(Number(val).toFixed(2));

  return (
    <div className="bg-white py-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>

        {/* KPIs of the tasks */}
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <ul className="d-flex align-items-center gap-2">
            <li role="presentation">
              Tasks : <span className="text-primary">{fmt(taskList.length)}</span>
            </li>

            <li role="presentation">
              Pending : <span className="text-primary">{fmt(pendingTaskCount)}</span>
            </li>

            <li role="presentation">
              In progress :{" "}
              <span className="text-primary">{fmt(inProgressTaskCount)}</span>
            </li>

            <li role="presentation">
              Completed :{" "}
              <span className="text-primary">{fmt(completedTaskCount)}</span>
            </li>

            <li role="presentation">
              <Link
                to="#"
                className="d-flex align-items-center justify-content-center dropdown-toggle fw-bold"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="material-symbols-outlined icon-fill fw-bold">
                  more_vert
                </span>
              </Link>

              <ul className="dropdown-menu dropdown-menu-end p-3 bg-white border-0 rounded-3 shadow">
                <li role="presentation" className="mb-2">
                  Delayed :{" "}
                  <span className="text-primary">{fmt(delayedTaskCount)}</span>
                </li>
                <li role="presentation" className="mb-2">
                  Following :{" "}
                  <span className="text-primary">{fmt(followingTaskCount)}</span>
                </li>
                <li role="presentation" className="mb-2">
                  Testing :{" "}
                  <span className="text-primary">{fmt(testingTaskCount)}</span>
                </li>
                <li className="mb-2" role="presentation">
                  Completed :{" "}
                  <span className="text-primary">{fmt(completedTaskCount)}</span>
                </li>
                <li className="mb-2" role="presentation">
                  Planned :{" "}
                  <span className="text-primary">{fmt(totalTaskHours)}</span>
                </li>
                <li role="presentation" className="mb-2">
                  Dedicated :{" "}
                  <span className="text-primary">{fmt(totalTaskLogHours)}</span>
                </li>{" "}
                <li role="presentation" className="mb-2">
                  Pending hours :{" "}
                  <span className="text-primary">{fmt(taskTotalPendingHours)}</span>
                </li>
                <li role="presentation">
                  Desviation :{" "}
                  <span className="text-primary">
                    {fmt(totalTaskHours - totalTaskLogHours)}
                  </span>
                </li>
              </ul>
            </li>
          </ul>

          {/* KPIs ends here  */}

          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>

          <div className="dropdown">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("List View")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/mytasklist`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    list
                  </span>
                  <span className="d-block">{t("List View")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/mytaskkanbankit`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">{t("Kanban View")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/mytaskgantt`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    insert_chart_outlined
                  </span>
                  <span className="d-block">{t("Gantt View")}</span>
                </Link>
              </li>
            </ul>
          </div>

          <div className="dropdown">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedTaskIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedTaskIds.length === 0 ? undefined : "#addLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedTaskIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedTaskIds.length === 0 ? undefined : "#addFollowers"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person
                  </span>
                  <span className="d-block">{t("Add Followers")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    if (selectedTaskIds.length > 0) {
                      updateBulkTaskHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Task")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    if (selectedTaskIds.length > 0) {
                      updateTaskInputHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Massive")}</span>
                </Link>
              </li>
              {/* <!-- ========== Start bulk task Section ========== --> */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedTaskIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedTaskIds.length === 0 ? undefined : "#addAssingTask"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    task
                  </span>
                  <span className="d-block">{t("Assign Tasks")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              {/* <!-- ========== End bulk task Section ========== --> */}
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedTaskIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedTaskIds.length === 0
                      ? undefined
                      : "#createAlertModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    alarm
                  </span>
                  <span className="d-block">{t("Create alert")}</span>
                </Link>
              </li>
              {/* <!-- ========== Start schedule update Section ========== --> */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  type="button"
                  onClick={() => {
                    if (selectedTaskIds.length > 0) {
                      updateScheduleStateHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    schedule
                  </span>
                  <span className="d-block">{t("Update Schedule")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              {/* <!-- ========== End schedule update Section ========== --> */}
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="#"
                  onClick={downloadAsExcel}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    download
                  </span>
                  <span className="d-block">{t("Download as Excel")}</span>
                </Link>
              </li>
              {/* <!-- ========== Start massive delete task Section ========== --> */}
              <hr className="dropdown-divider" />
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedTaskIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  data-bs-toggle={
                    selectedTaskIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedTaskIds.length === 0
                      ? undefined
                      : "#projectTaskDeleteModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete Tasks")}</span>
                </Link>
              </li>
              {/* <!-- ========== End massive delete task Section ========== --> */}
            </ul>
          </div>
          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#taskAdvanceFilter"
            aria-controls="taskAdvanceFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>

          <button
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#addMultipleTaskModal"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Quick Add")}</span>
          </button>

          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#addTask_view"
            aria-controls="addTask_view"
            onClick={() => {
              setselectedTaskModerator(userInfo._id);
            }}
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span className="d-block">{t("Add")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MyTaskListHeader;
